import React, { useEffect, useState } from "react";
import { Button, Table, Card, Form } from 'react-bootstrap';
import { useHistory, useParams } from "react-router-dom";
import { Routes } from "routes";
import { useEnterpriseGroupMutation, useGetERUforEAMutation, useGetMappedRUEUListMutation, useUpdateMappingMutation, useUserDropDownMutation } from "Services/services";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: "btn btn-secondary me-3",
      cancelButton: "btn btn-gray",
    },
    buttonsStyling: false,
  })
);

export default () => {
  const history = useHistory();

  const [tableData, setTableData] = useState([]);

  const [enterprise, setEnterprise] = useState("");
  const [eOptions, setEOptions] = useState([]);
  const [enterpriseRepUser, setEnterpriseRepUser] = useState("");
  const [eRUOptions, setERUOptions] = useState([]);

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  const userId = userObject.id;

  // edit functionality
  const { id } = useParams();
  const [rowToEdit, setRowToEdit] = useState([]);


  useEffect(() => {
    const init = async () => {
      if (id) {
        await fetchWholeData(id);   // wait for it to finish
      }

      if (userType === "enterprise") {
        setEnterprise(userId); // still async, but you already have userId
        await fetchEnterpRepUserDropdown(userId);
        await fetchTableData(userId);
      } else {
        await fetchEnterpDropdown();
      }
    };

    init();
  }, []);


  // fetch data to edit
  const [templateList] = useGetMappedRUEUListMutation();
  const fetchWholeData = (rowId) => {
    templateList({
      pageNumber: 1,
      limit: '',
      search: '',
    })
      .then((response) => {
        if (response.data?.statusCode === 200) {
          const tableData = response.data?.data?.result?.data || [];
          const selectedRow = tableData.filter(items => items.id === rowId);
          const enterId = selectedRow[0].associated_enterprise_id;
          setRowToEdit(selectedRow[0]);
          setEnterprise(enterId);
          setSelectedData(selectedRow[0].reported_enterprise);
          setEnterpriseRepUser(selectedRow[0].id);

          fetchEnterpRepUserDropdown(enterId);
          fetchTableData(enterId);
        } else {
          alert("Error fetching user data in RU_EU.");
        }
      })
      .catch((error) => {
        alert("Error fetching user data in RU_EU", error);
      });
  };

  // fetch enterprise
  const [userDropDown] = useUserDropDownMutation();
  const fetchEnterpDropdown = async () => {
    try {
      const response = await userDropDown({ user_type: "4" });
      if (response?.data?.statusCode === 200) {
        const userOptions = response.data.data.user_details.map((user) => ({
          value: user.id,
          label: user.user_name,
        }));
        setEOptions(userOptions);

      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  // main table
  const [routesList] = useEnterpriseGroupMutation();
  const fetchTableData = async (entId) => {
    routesList({ user_id: entId, pageNumber: 1, limit: "" })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const data = response.data.data.result.data;
          const onlyEU = data.filter((user) => user.user_type_id !== 8);
          setTableData(onlyEU);
        } else {
          setTableData([]);
        }
      })
      .catch((error) => {
        // alert("Error fetching enterprise users", error);
        setTableData([]);
      });
  };

  // fetch enterprise rept user
  const [reportingUserDropDown] = useGetERUforEAMutation();
  const fetchEnterpRepUserDropdown = async (entId) => {
    if (!id){
      setEnterpriseRepUser(null);
    }
    try {
      const response = await reportingUserDropDown({ user_id: entId });
      if (response?.data?.statusCode === 200) {
        const userOptions = response.data.data.dropDownData.map((user) => ({
          value: user.id,
          label: user.user_name,
        }));
        setERUOptions(userOptions);
      } else {
        setERUOptions([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setERUOptions([]);
      console.error("Error fetching user data", error);
    }
  };


  // useEffect(() => {
  //   if (id) {
  //     setEnterprise(rowToEdit.associated_enterprise_id)
  //     setSelectedData(rowToEdit.reported_enterprise);
  //     setEnterpriseRepUser(rowToEdit.id);
  //   }

  // }, [rowToEdit, fetchEnterpDropdown, fetchEnterpRepUserDropdown, fetchTableData])

  const selectEnterp = (selectedOption) => {
    if (selectedOption != null) {
      setEnterprise(selectedOption.value);
      fetchEnterpRepUserDropdown(selectedOption.value);
      fetchTableData(selectedOption.value);
    } else return setEnterprise("");
  };
  const selectEnterpRepUser = (selectedOption) => {
    if (selectedOption != null) {
      setEnterpriseRepUser(selectedOption.value);
    } else return setEnterpriseRepUser("");
  };

  // Get selected data for payload
  const [selectedData, setSelectedData] = useState([]);
  const handleRowSelect = (userId) => {
    setSelectedData((prev) => {
      if (prev.includes(userId)) {
        // remove if already selected
        return prev.filter((id) => id !== userId);
      } else {
        // add if not selected
        return [...prev, userId];
      }
    });

  };


  const [gotError, setGotError] = useState(false);

  const [updateMapping] = useUpdateMappingMutation();
  const handleSubmitSelected = () => {
    if (!enterprise || !enterpriseRepUser || selectedData.length === 0) {
      setGotError(true);
      return;
    } else {
      setGotError(false);
    }

    const postData = {
      update_enterprise_user: selectedData,
      user_id: enterpriseRepUser,
    };

    updateMapping(postData)
      .then((success) => {
        if (
          success?.data.statusCode >= 200 ||
          success?.data.statusCode <= 204
        ) {
          const confirmMessage = success?.data?.message || "Sucessfuly Done!";
          SwalWithBootstrapButtons.fire("Success", confirmMessage, "success");
          setTimeout(() => {
            history.push(Routes.ReportingUser.path);
          }, 2000);
        } else {
          const confirmMessage =
            success?.data?.message || "Something went wrong!";
          SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
        }
      })
      .catch((error) => {
        const confirmMessage = error?.message || "Something went wrong!";
        SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
      });
  };

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  const TableRow = (props) => {
    return (
      <tr className="border-bottom">
        <td>
          <span className="fw-normal">{props.name}</span>
        </td>
        <td>
          <span className="fw-normal">{props.user_name}</span>
        </td>
        <td>
          <span className="fw-normal">{props.email}</span>
        </td>
        <td>
          <span className="fw-normal">{props.phone}</span>
        </td>
        <td>
          <input
            type="checkbox"
            style={{ cursor: "pointer" }}
            checked={selectedData.includes(props.id)}
            onChange={() => handleRowSelect(props.id)}
          />
        </td>
      </tr>
    );
  };

  return (
    <Card border={1}>

      <div className="d-flex flex-wrap align-items-start gap-2">
        {userType !== "enterprise" && (
          <Form.Group className="mb-3" style={{ minWidth: "250px" }}>
            <RequiredLabel label="Enterprise" />
            <Select
              // isClearable
              options={eOptions}
              placeholder="Select User"
              className="mb-3 fmxw-300"
              isDisabled={id}
              value={
                eOptions.find((opt) => opt.value == enterprise) || null
              }
              onChange={(selectedOption) => {
                selectEnterp(selectedOption);
              }}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  borderColor: gotError && !enterprise ? '#dc3545' : gotError && !enterprise ? '#65BB82' : provided.borderColor,
                  borderRadius: '0.75rem',
                }),
              }}
            />
            {gotError && !enterprise && (
              <div className="invalid-feedback d-block">
                Enterprise is required.
              </div>
            )}
          </Form.Group>
        )}

        <Form.Group
          className="mb-3"
          style={{ minWidth: "250px" }}
        >
          <RequiredLabel label="Enterprise Reporting User" />
          <Select
            // isClearable
            options={eRUOptions}
            placeholder="Select User"
            value={
              eRUOptions.find((opt) => opt.value === enterpriseRepUser) ||
              null
            }
            onChange={(selectedOption) => {
              selectEnterpRepUser(selectedOption);
            }}
            styles={{
              control: (provided, state) => ({
                ...provided,
                borderColor: gotError && !enterpriseRepUser ? '#dc3545' : gotError && enterpriseRepUser ? '#65BB82' : provided.borderColor,
                borderRadius: '0.75rem',
              }),
            }}
          />
          {gotError && !enterpriseRepUser && (
            <div className="invalid-feedback d-block">
              Enterprise User is required.
            </div>
          )}
        </Form.Group>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table responsive className="align-items-center table-flush table-outlines">
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Enterprise User</th>
                <th className="border-bottom">Enterprise User Username</th>
                <th className="border-bottom">Enterprise User Mail</th>
                <th className="border-bottom">Enterprise User Number</th>
                <th className="border-bottom">Select</th>
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => <TableRow key={index} {...u} />)
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {gotError && selectedData.length === 0 && (
        <div className="invalid-feedback d-block">
          Select atleast one list.
        </div>
      )}

      <Card.Footer className="mt-3 p-0 border-0 d-flex flex-wrap align-items-center justify-content-end">
        <Button
          variant="secondary"
          className="my-2"
          type="submit"
          onClick={handleSubmitSelected}
        >
          Save
        </Button>
      </Card.Footer>
    </Card>
  );
};
